<template>
    <div class="card">
      <div class="card-title">各地区事件水平</div>
      <div ref="chartRef" class="chart-container"></div>
    </div>
  </template>
  
  <script setup>
  import { onMounted, ref } from 'vue'
  import * as echarts from 'echarts'
  
  const chartRef = ref(null)
  
  const spendData = [
    { value: 300, name: '数据泄露' },
    { value: 450, name: '重大漏洞' },
    { value: 200, name: 'APT事件' },
    { value: 150, name: '恶意软件' },
    { value: 100, name: '前沿技术' },
  ]
  
  onMounted(() => {
    const chart = echarts.init(chartRef.value)
    chart.setOption({
      tooltip: {
        trigger: 'item',
        formatter: '{b}: {c} ({d}%)'
      },
      legend: {
        bottom: '5%',
        textStyle: { color: '#fff' }
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '60%'],
          label: {
            color: '#fff',
            formatter: '{b}\n{d}%'
          },
          data: spendData
        }
      ]
    })
  })
  </script>
  
  <style scoped>
  .card {
    background: rgba(0, 52, 101, 0.7);
    border-radius: 8px;
    padding: 16px;
    color: #ffffff;
  }
  
  .card-title {
    font-size: 16px;
    font-weight: bold;
    color: #00ffff;
    margin-bottom: 12px;
  }
  
  .chart-container {
    width: 100%;
    height: 260px;
  }
  </style>
  